import { SvgIcon, SvgIconProps } from "@mui/material";

export default function WakeStudentsIcon(props: SvgIconProps) {
    function guidGenerator() {
        var S4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (`${S4() + S4()  }-${  S4()  }-${  S4()  }-${  S4()  }-${  S4()  }${S4()  }${S4()}`);
    }
    const id = guidGenerator();
    return (
        <SvgIcon {...props} viewBox="0 0 1024 1024"><defs><clipPath id={id}><circle cx="512" cy="512" r="512" fill="none" /></clipPath></defs><g clipPath={`url(#${id})`}><rect width="1024" height="1024" fill="#758ec2" /><path d="M250,201.21h147.4a10,10,0,0,1,10,10V812.79a10,10,0,0,1-10,10H380a140,140,0,0,1-140-140V211.21a10,10,0,0,1,10-10Z" fill="#fff" /><rect x="428.3" y="373.9" width="167.4" height="448.9" rx="10" fill="#fff" /><path d="M756.62,201.21H774a10,10,0,0,1,10,10V812.79a10,10,0,0,1-10,10H626.62a10,10,0,0,1-10-10V341.21A140,140,0,0,1,756.62,201.21Z" transform="translate(1400.64 1024) rotate(-180)" fill="#fff" /></g></SvgIcon>
    )
}